import React from 'react';
import { Route, IndexRoute } from 'react-router';

import { default as App } from './containers/App';
import RecipientComponent from './components/recipient/RecipientComponent';
import NotFoundPage from './components/NotFoundPage.js';

import { default as LoginContainer } from './containers/LoginContainer.js';
import { default as RegisterContainer } from './containers/RegisterContainer.js';
import { default as DispatcherRegisterContainer } from './containers/DispatcherRegisterContainer.js';
import { default as ResetContainer } from './containers/ResetContainer.js';
import { default as LogoutContainer } from './containers/LogoutContainer.js';
import { default as ConfirmationContainer } from './containers/ConfirmationContainer.js';
import { default as AdminDashboardContainer } from './containers/AdminDashboardContainer.js';
import { default as DashboardContainer } from './containers/DashboardContainer.js';
import { default as DispatcherDashboardContainer } from './containers/DispatcherDashboardContainer.js';
import { default as FleetOrderCreationContainer } from './containers/FleetOrderCreationContainer.js';
import { default as RecipientContainer } from './containers/RecipientContainer.js';
import { default as SettingsContainer } from './containers/SettingsContainer.js';

import { default as ReportsContainer } from './containers/ReportsContainer.js';
import { default as FleetOwnerContainer } from './containers/FleetOwnerContainer.js';
import { default as OnDemandContainer } from './containers/OnDemandContainer';

import { default as AddCardComponent } from './components/cards/AddCardComponent.js';
import { default as PayComponent } from './components/cards/PayComponent.js';
import AnalyticsComponent from './components/settings/AnalyticsComponent.js';

import LoopbackHttp from './businessLogic/LoopbackHttp.js';
import {checkForTokenizationResponse} from './businessLogic/pay.js';

checkForTokenizationResponse();

const getIndexComponent = () => {

  const isDispatcher = LoopbackHttp.isDispatcher;
  const isOperator = LoopbackHttp.isOperator;
  const isAdministrator = LoopbackHttp.isAdministrator;
  const isDispatcherActive = LoopbackHttp.isUserActive();
  const isFleet = LoopbackHttp.isFleet;
    if (isDispatcher) {
      if(!isDispatcherActive){
        return ConfirmationContainer;
      }
      return DispatcherDashboardContainer;
    } else if (isOperator) {
        return getOperatorDashType();
    } else if (isAdministrator) {
        return AdminDashboardContainer;
    } else if (isFleet) {
        return getFleetDashType();
    } else if(LoopbackHttp.requireLogin){
        return LoginContainer;
    }
};

const getFleetDashType = () => {
  let dashboardType = localStorage.getItem('dashboardType');
    if(dashboardType==='onDemand')
      return OnDemandContainer;
    else
      return FleetOwnerContainer;
};

const getOperatorDashType = () => {
  let dashboardType = localStorage.getItem('dashboardType');
    if(dashboardType==='onDemand')
      return OnDemandContainer;
    else
      return DashboardContainer;
};


export const appRoutes =(
  <Route path="/" component={App}>

    <Route path="login" component={LoginContainer} />
    <Route path="registration" component={RegisterContainer} />
    <Route path="dispatcherRegistration" component={DispatcherRegisterContainer} />
    <Route path="logout" component={LogoutContainer} />
    <Route path="reset" component={ResetContainer} />
    <Route path="confirmation" component={ConfirmationContainer} />
    <IndexRoute component={getIndexComponent()} />

    <Route onEnter={LoopbackHttp.requireLogin}>
      <Route onEnter={LoopbackHttp.requireOperator}>
        <Route path="dashboard" component={getOperatorDashType()} />
      </Route>

      <Route onEnter={LoopbackHttp.requireAdministrator}>
        <Route path="admindashboard" component={AdminDashboardContainer} />
      </Route>

      <Route onEnter={LoopbackHttp.requireFleet}>
        <Route path="fleetOwnerDashboard" component={getFleetDashType()} />
      </Route>

      <Route onEnter={LoopbackHttp.requireDispatcher}>
        <Route path="dispatcherDashboard" component={DispatcherDashboardContainer} />
      </Route>
    </Route>

    <Route path="settings" component={SettingsContainer} />
    <Route path="analytics" component={AnalyticsComponent} />
    <Route path="addCard" component={AddCardComponent} />
    <Route path="pay" component={PayComponent} />

    <Route path="createNewOrder" component={FleetOrderCreationContainer} />
    <Route path="returnFleetOrder" component={FleetOrderCreationContainer} />
    <Route path="updateOrder" component={FleetOrderCreationContainer} />
    <Route path="logout" component={LogoutContainer} />
    <Route path="reports" component={ReportsContainer} />
    <Route path="recipient/:orderId" component={RecipientContainer} />
    <Route path="*" onEnter={NotFoundPage} />    
  </Route>
);

export const recipientRoutes =(
  <Route path="/" component={App}>
    <Route path="recipient/:orderId" component={RecipientContainer} />
    <Route component={RecipientContainer}>
      <IndexRoute component={RecipientComponent} />
    </Route>
  </Route>
);



// WEBPACK FOOTER //
// ./src/routes.js